module.exports = __webpack_public_path__ + "img/_access_denied.bad3c534.svg";